import { Component, OnInit, ViewChild } from '@angular/core';

import { Observable, Subject, Subscription, BehaviorSubject, ReplaySubject } from "rxjs";

import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

import { Device } from '../device.model';
import { Controller, IP } from '../controller.model';
import { DeviceService } from '../device.service';

import { Location } from '../../locations/location.model';
import { LocationService } from '../../locations/location.service';

import { Organization } from '../../organization/organization.model';
import { OrganizationService } from '../../organization/organization.service';

import { SelectComponent } from '../../shared/select/select.component';

import { NotificationService } from '../../shared/notification/notification.service';

@Component({
  selector: 'app-device-list',
  templateUrl: './device-list.component.html',
  styleUrls: ['./device-list.component.scss']
})
export class DeviceListComponent implements OnInit {

  public devices: Device[] = [];
  public deviceList: Device[] = [];
  public disabledDeviceList: Device[] = [];

  public activeConnection: Controller | null = null;
  public activeIP: IP | null = null;

  public searchFilter: string;
  public allowedFilters: string[] = ['name', 'code', 'org_id', 'hologram_device_id', 'vpn_port', 'vpn_ip', 'online'];

  public editing: boolean = false;
  public selectedDevices: Device[] = [];
  public selectedDeviceIds: number[] = [];
  public bulkAction: any = null;
  public selectedDeviceName: any = null;
  public selectedOrgId: any = null;
  public selectedLocationId: any = null;
  public active = 1;

  @ViewChild(SelectComponent) selectComponent!: SelectComponent;

  constructor(
    public deviceService: DeviceService,
    public locationService: LocationService,
    public notificationService: NotificationService,
    public organizationService: OrganizationService,
		public modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.formatDevicesForList(this.deviceService.devices.slice());

    this.deviceService.devicesSubject.subscribe( (devices) => {
      this.formatDevicesForList(devices);
    })
  }

  formatDevicesForList(devices) {
    let tmpDevices: Device[] = [];
    let tmpDisabledDevices: Device[] = [];
    devices.forEach((device) => {
      let tmpDevice = new Device(device);
      tmpDevice.location = this.locationService.location(device.location_id)
      tmpDevice.selected = false;
      if (tmpDevice.disabled_for_ordinary_users) {
        tmpDisabledDevices.push(tmpDevice);
      } else {
        tmpDevices.push(tmpDevice);
      }
    });
    this.devices = tmpDevices;
    this.deviceList = tmpDevices;
    this.disabledDeviceList = tmpDisabledDevices;
    if (this.selectComponent) this.filterDevices(this.selectComponent.matches);
  }

  get formattedDevicesObservable() : Subject<Device[]> {
    return this.deviceService.devicesSubject;
  }

  activateDevice(device: Device) {
    this.deviceService.activateDevice(device.id);
  }

  deactivateDevice(device: Device) {
    this.deviceService.deactivateDevice(device.id);
  }

  filterDevices(matches) {
    if (!matches) {
      this.deviceList = this.devices;
    } else {
      this.deviceList = this.devices.filter((device) => matches.includes(device.id));
    }
  }

	updateSelectedDevices() {
    let currentList = this.active == 1 ? this.deviceList : this.disabledDeviceList;
    this.selectedDevices = currentList.filter((device) => device.selected);
    this.selectedDeviceIds = this.selectedDevices.map((device) => device.id);
	}

  authenticateGuac(device) {
    let guac_sub = this.deviceService.getGuacToken(device.connection.id).subscribe((ret) => {
      if (ret && ret.url && guac_sub) {
        var win = window.open(ret.url, '_blank');
        if (win) {
          win.focus();
        }

        guac_sub.unsubscribe();
      }
    })
  }

	openBulkEditModal(content) {
    this.bulkAction = null;
    this.selectedOrgId = null;
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'xl'}).result.then((result) => {
      if (result === 'save') {
        this.performBulkAction();
      }
    }, (reason) => {
      console.log(reason);
    });
  }

  performBulkAction() {
    switch (this.bulkAction) {

      case "activate":
        this.deviceService.bulkActivate(this.selectedDevices)
          .subscribe((result) => console.log(result));
        break;

      case "deactivate":
        this.deviceService.bulkDeactivate(this.selectedDevices)
          .subscribe((result) => console.log(result));
        break;

      case "pause_cell":
        this.deviceService.pauseCellular(this.selectedDevices)
          .subscribe((result) => console.log(result));
        break;

      case "unpause_cell":
        this.deviceService.unpauseCellular(this.selectedDevices)
          .subscribe((result) => console.log(result));
        break;

      case "delete":
        this.deviceService.bulkDelete(this.selectedDevices)
          .subscribe((result) => console.log(result));
        break;

      case "edit":
        /*
        let updateProps: any = {};
        if (this.selectedDeviceName) updateProps.name = this.selectedDeviceName;
        if (this.selectedOrgId) updateProps.org_id = this.selectedOrgId;
        if (this.selectedLocationId) updateProps.location_id = this.selectedLocationId;
        this.deviceService.bulkEdit(this.selectedDevices, updateProps)
          .subscribe((result) => {
            this.selectedDeviceName = null;
            this.selectedOrgId = null;
            this.selectedLocationId = null;
          });
        */
        break;

    }

  }
}
